/**
 * @fileoverview Federal tax classification options for W9 tax form
 * @description Provides a frozen array of federal tax classification options for use in W9 tax form dropdown selections.
 * Each option contains a label and value pair representing the IRS federal tax classification types.
 */

/**
 * Frozen array of federal tax classification options for W9 tax form
 * @constant {Array<{label: string, value: string}>} FederalTaxClassificationOptions
 * @description Contains federal tax classification options as defined by IRS Form W-9.
 * These classifications indicate the type of entity for tax purposes.
 */
export const FederalTaxClassificationOptions = Object.freeze([
    { label: "Individual/Sole Proprietor", value: "Individual/Sole Proprietor" },
    { label: "C Corporation", value: "C Corporation" },
    { label: "S Corporation", value: "S Corporation" },
    { label: "Partnership", value: "Partnership" },
    { label: "Trust/Estate", value: "Trust/Estate" },
    { label: "Limited Liability Company (LLC)", value: "Limited Liability Company (LLC)" },
    { label: "Other", value: "Other" }
]);